export const COMPANY_NAME = "Pay+";

// API endpoints para conectarse con el backend (ejemplos)
export const API_BASE_URL = "/api";

export const API_ROUTES = {
  // Auth
  LOGIN: `${API_BASE_URL}/auth/login`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  
  // Operaciones
  RECARGAS: `${API_BASE_URL}/operations/recargas`,
  PAQUETES: `${API_BASE_URL}/operations/paquetes`,
  FACTURAS: `${API_BASE_URL}/operations/facturas`,
  SEGUROS: `${API_BASE_URL}/operations/seguros`,
  
  // Consultas
  CONSULTA_DEUDA: `${API_BASE_URL}/consultas/deuda`,
  CONSULTA_PAQUETES: `${API_BASE_URL}/consultas/paquetes`,
  
  // Transacciones
  TRANSACCIONES: `${API_BASE_URL}/transactions`,
  
  // Wallet
  WALLET: `${API_BASE_URL}/wallet`,
  WALLET_RECARGAR: `${API_BASE_URL}/wallet/recargar`,
};

// Proveedores de República Dominicana
export const PROVIDERS = {
  RECARGAS: [
    { id: 'claro', name: 'Claro', logo: '/assets/logos/claro.png' },
    { id: 'altice', name: 'Altice', logo: '/assets/logos/altice.png' },
    { id: 'viva', name: 'Viva', logo: '/assets/logos/viva.png' },
  ],
  PAQUETES: [
    { id: 'claro', name: 'Claro', logo: '/assets/logos/claro.png' },
    { id: 'altice', name: 'Altice', logo: '/assets/logos/altice.png' },
    { id: 'viva', name: 'Viva', logo: '/assets/logos/viva.png' },
  ],
  FACTURAS: [
    { id: 'edesur', name: 'EDESUR', logo: '/assets/logos/edesur.png' },
    { id: 'edenorte', name: 'EDENORTE', logo: '/assets/logos/edenorte.png' },
    { id: 'edeeste', name: 'EDEESTE', logo: '/assets/logos/edeeste.png' },
    { id: 'caasd', name: 'CAASD', logo: '/assets/logos/caasd.png' },
    { id: 'claro', name: 'Claro', logo: '/assets/logos/claro.png' },
    { id: 'altice', name: 'Altice', logo: '/assets/logos/altice.png' },
    { id: 'viva', name: 'Viva', logo: '/assets/logos/viva.png' },
  ],
  SEGUROS: [
    { id: 'segurosbanreservas', name: 'Seguros Banreservas', logo: '/assets/logos/segurosbanreservas.png' },
    { id: 'mapfre', name: 'Mapfre', logo: '/assets/logos/mapfre.png' },
    { id: 'universalseguros', name: 'Universal Seguros', logo: '/assets/logos/universalseguros.png' },
  ]
};

// Montos predefinidos para recargas
export const PREDEFINED_AMOUNTS = [25, 50, 100, 150, 200, 250];
